import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {AppContext} from "../../../../App";
import {initTamponiState, TAMPONI_INITIAL_STATE, TamponiReducer} from "../../../../reducers/TamponiReducer";
import {creaAgendaPrenotazioni, getAllAgende} from "../../../../services/TamponiServices";
import clsx from "clsx";
import {
	Button,
	Card,
	CardActionArea,
	CardContent,
	CardHeader, Chip, DialogActions, Menu, MenuItem,
	Table,
	TableBody,
	TableCell,
	TableRow, Tooltip,
	Typography
} from "@mui/material";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import moment from "moment";
import SimpleDialog from "../../../widgets/dialogs/SimpleDialog";
import {FormProvider, useForm} from "react-hook-form";
import {setOpenSnackbar} from "../../../../services/AppServices";
import {AgendaForm} from "./AgendaForm";
import {amber, green, grey, red} from "@mui/material/colors";
import {MoreVertTwoTone} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";

const VisualizzaAgende = () => {
	const classes = BaseStyle();
	const appContext = useContext(AppContext);
	const [state, dispatch] = useReducer(TamponiReducer, TAMPONI_INITIAL_STATE, initTamponiState);
	let fasce = new Array(12).fill(":00");
	const [selected, setSelected] = useState("");
	const methods = useForm({
		mode: "onChange",
	});
	const [submit, setSubmit] = useState(false);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [filterAgende, setFilterAgende] = useState(0);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = (item) => {
		if (item) {
			setFilterAgende(item);
		}
		setAnchorEl(null);
	};

	useEffect(() => {
		let enable = null;
		if (filterAgende === 1) {
			enable = true;
		}
		if (filterAgende === 2) {
			enable = false;
		}
		getAllAgende({enable: enable}, dispatch);
	}, [dispatch, selected, filterAgende])

	const onSubmit = useCallback((data) => {
		setSubmit(true);
		let dataAgenda = new Date(data.data);
		dataAgenda?.setHours(0);
		dataAgenda?.setMinutes(0);
		dataAgenda?.setSeconds(0);
		dataAgenda?.setMilliseconds(0);
		let agenda = {
			...selected,
			...data,
			data: dataAgenda,
			postiR: data.postiI,
		};
		let totI = 0;
		let totR = 0;
		for (let i = 1; i <= fasce.length; i++) {
			agenda = {
				...agenda,
				["fascia" + i + "R"]: data["fascia" + i + "I"],
			}
			totI += parseInt(agenda["fascia" + i + "I"]);
			totR += parseInt(agenda["fascia" + i + "R"]);
		}
		agenda = {
			...agenda,
			postiI: totI,
			postiR: totR,
		}
		creaAgendaPrenotazioni(agenda, dispatch)
	}, [dispatch, fasce, selected])

	useEffect(() => {
		if (submit && !state.loadingAddAgenda && state.errorAddAgenda === "") {
			setSubmit(false);
			methods.reset();
			setSelected("");
			setOpenSnackbar("success", "Agenda agiornata con successo", appContext.dispatch);
		} else if (submit && !state.loadingAddAgenda && state.errorAddAgenda !== "") {
			setSubmit(false);
			setOpenSnackbar("error", state.errorAddAgenda, appContext.dispatch);
		}
	}, [submit, state.loadingAddAgenda, state.errorAddAgenda, appContext.dispatch, methods])

	return (
        <React.Fragment>
            <Card className={clsx(classes.roundBorder)} style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography
						variant={"h6"}><b>Visualizza e modifica le agende</b></Typography>}
					action={
						<React.Fragment>
							<Tooltip title={"Filtra per"}>
								<IconButton onClick={handleClick} size="large">
									<MoreVertTwoTone/>
								</IconButton>
							</Tooltip>
							<Menu
								PaperProps={{
									className: classes.roundBorder
								}}
								anchorEl={anchorEl}
								keepMounted
								open={Boolean(anchorEl)}
								onClose={handleClose}
							>
								<MenuItem onClick={() => handleClose(0)}
								          style={filterAgende === 0 ? {backgroundColor: grey[100]} : {}}> Tutte le agende</MenuItem>
								<MenuItem onClick={() => handleClose(1)} style={filterAgende === 1 ? {backgroundColor: grey[100]} : {}}>Solo
									attive</MenuItem>
								<MenuItem onClick={() => handleClose(2)} style={filterAgende === 2 ? {backgroundColor: grey[100]} : {}}>Solo
									inattive</MenuItem>
							</Menu>
						</React.Fragment>
					}
				/>
				<CardContent style={{flexGrow: 1, height: "80vh"}}>
					{
						state.loadingGetAllAgende ?
							<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
								<CardHeader
									avatar={<Skeleton variant="circular" height={40} width={40}/>}
									title={<Skeleton width={180}/>}
									subheader={<Skeleton width={260}/>}
									action={<Skeleton variant="circular" height={20} width={20}/>}
									style={{paddingBottom: 2}}
								/>
								<CardContent style={{paddingTop: 0, marginTop: -35}}>
									<Skeleton height={200}/>
								</CardContent>
							</Card> : state.errorGetAllAgende !== "" ?
								<Alert severity="error" style={{borderRadius: 24}}>
									<AlertTitle>Errore</AlertTitle>
									Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
									sviluppatori.
								</Alert> :
								state.agende.length === 0 ? "Non sono presenti agende" :
									state.agende
										.map((agenda, index) => {
											return (
												<Card className={clsx(classes.roundBorder, classes.mailCard)} key={index}>
													<CardActionArea onClick={() => {
														methods.reset(agenda)
														setSelected(agenda)
													}}>
														<CardHeader
															title={
																<Typography variant={"subtitle2"} style={{position: "relative"}}>
																	<b>{agenda.luogo + " - " + agenda.tipo}</b>
																</Typography>
															}
															subheader={
																<Typography variant={"body2"} color={"textSecondary"}>
																	{moment(agenda.data).format("DD/MM/YYYY")}
																</Typography>
															}
															action={
																<Chip style={{
																	fontSize: 18,
																	color: "#FFF",
																	minWidth: 110,
																	backgroundColor:
																		parseInt(agenda["postiR"]) === parseInt(agenda["postiI"]) ? green[500] :
																			parseInt(agenda["postiR"]) === 0 ? red[500] : amber[700],
																}}
																      label={
																	      <React.Fragment>
																		      <b>{agenda["postiR"]}</b> / {agenda["postiI"]}
																	      </React.Fragment>
																      }/>
															}
														/>
														<CardContent style={{paddingTop: 0, overflowY: "auto"}}>
															<Table size={"small"}>
																<TableBody>
																	<TableRow>
																		{
																			fasce.map((fascia, index) => {
																				return (<TableCell key={index} style={{
																					/*textOrientation: "mixed",
																					 writingMode: "vertical-rl",
																					 transform: "rotate(225deg)",*/
																				}}>
																					<Typography style={{fontSize: 12}} align={"center"}>
																						fascia<br/>
																						{(index + 8) + " - " + (index + 9)}
																					< /Typography>
																				</TableCell>)
																			})
																		}
																	</TableRow>
																	<TableRow>
																		{
																			fasce.map((fascia, index) => {
																				return (
																					<TableCell key={index} className={classes.hoverCell} style={{
																						color: "#FFF",
																						backgroundColor:
																							parseInt(agenda["fascia" + (index + 1) + "I"]) === 0 ? grey[500] :
																								parseInt(agenda["fascia" + (index + 1) + "R"]) === parseInt(agenda["fascia" + (index + 1) + "I"]) ?
																									green[500] : parseInt(agenda["fascia" + (index + 1) + "R"]) === 0 ? red[500] : amber[700]
																					}}>
																						<Typography>
																							<span
																								style={{
																									fontSize: 20,
																									fontWeight: "bolder",
																								}}>
																								{agenda["fascia" + (index + 1) + "R"]}
																							</span>
																							<span
																								style={{fontSize: 14}}>/{agenda["fascia" + (index + 1) + "I"]}
																							</span>
																						</Typography>
																						{/*<Chip
																						 color={"primary"}
																						 label={agenda["fascia" + (index + 1) + "Tag"] ? agenda["fascia" + (index + 1) + "Tag"] : "-"}/>*/}
																					</TableCell>)
																			})
																		}
																	</TableRow>
																</TableBody>
															</Table>
														</CardContent>
													</CardActionArea>
												</Card>
											)
										})
					}
				</CardContent>
			</Card>
            {
				selected !== "" &&
				<SimpleDialog
					maxWidth={"xl"}
					open={selected !== ""}
					handleClose={() => setSelected("")}
					title={"Modifica agenda"}
					content={
						<React.Fragment>
							<FormProvider {...methods}>
								<AgendaForm fasce={fasce}/>
							</FormProvider>
						</React.Fragment>
					}
					actions={<DialogActions>
						<Button size={"small"} className={classes.roundButton} variant={"text"} disabled={submit}
						        disableElevation
						        style={{borderRadius: 24}}
						        onClick={() => setSelected("")}>
							<b>Annulla</b>
						</Button>
						<Button size={"small"} className={classes.roundButton} variant={"contained"} color={"primary"}
						        disabled={submit} disableElevation
						        style={{borderRadius: 24}}
						        onClick={methods.handleSubmit(onSubmit)}>
							<b>Aggiorna agenda</b>
						</Button>
					</DialogActions>}
				/>
			}
        </React.Fragment>
    );
};

export default React.memo(VisualizzaAgende);
